// services/landingService.ts
import type { ContentResponse } from "types/content";
import apiClient from "./apiClient";
import { AxiosError } from "axios";
import serviceConfig from "config/serviceConfig";

/**
 * Fetch landing contents with language headers
 *
 * Backend mapping:
 * 1 = English
 * 2 = Russian
 * 3 = Turkish
 */
export const fetchContents = async ({
	LangID,
	WithContent,
}: {
	LangID: string; // "1" | "2" | "3"
	WithContent: string; // content group id
}): Promise<ContentResponse> => {
	try {
		const response = await apiClient.get<ContentResponse>(
			serviceConfig.routes.contents,
			{
				headers: {
					LangID, // backend expects header
					WithContent, // backend expects header
				},
			},
		);

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			const msg =
				error.response?.data?.message ||
				error.response?.data?.error ||
				"Failed to fetch contents";

			console.error("❌ API error [fetchContents]:", msg);
			throw new Error(msg);
		}

		console.error("❌ Unknown error [fetchContents]:", error);
		throw new Error("An unknown error occurred while fetching contents");
	}
};
